export const fonts = {
  SANS_SERIF: "'Nunito', sans-serif",
  SERIF: "'Playfair Display', serif",
} as const;
